import {createClient} from "contentful";

export const contentfulClient = createClient({
    space: "6d6ugs4miyvj",
    accessToken: "6FpQUAf3ruSHtJ_OYnyJYy2okUhvwWjz1zIBJtDTzE8"
});
